


















































import { Component, Vue } from 'vue-property-decorator'
import { EventEmitter } from 'events'
import { ExStore } from 'vuex'
import { bleDeviceNames, BleDeviceTypes } from '@/constants/ble'

@Component
export default class AccountSetting extends Vue {
  $store!: ExStore
  bleDeviceNames = bleDeviceNames
  connectionPending: { [address: string]: boolean } = {}
  events = new EventEmitter()

  supportedDeviceTypes = [
    BleDeviceTypes.ELECTRONIC_BLOOD_PRESSURE_MONITOR,
    BleDeviceTypes.MEDICAL_BLOOD_PRESSURE_MONITOR,
    BleDeviceTypes.ELECTRONIC_THERMOMETER,
    BleDeviceTypes.SPO2_MONITOR_MIGHTY_SAT,
    BleDeviceTypes.SPO2_MONITOR_TM1121,
    BleDeviceTypes.NONCONTACT_THERMOMETER,
    BleDeviceTypes.BLOOD_SUGAR_LEVEL_MEASUREMENT
  ]

  get bleDevices() {
    return this.$store.getters['ble/devices']
  }

  get connectedDevices() {
    const devices = this.bleDevices
    return Object.keys(devices)
      .filter(addr => {
        return devices[addr].logicalConnected
      })
      .sort((a1, a2) => {
        return devices[a1].deviceType - devices[a2].deviceType
      })
      .map(addr => devices[addr])
  }

  get disconnectedDevices() {
    const devices = this.bleDevices
    return Object.keys(devices)
      .filter(addr => {
        const device = devices[addr]
        return (
          !device.logicalConnected &&
          this.supportedDeviceTypes.indexOf(device.deviceType) !== -1
        )
      })
      .sort((a1, a2) => {
        return devices[a1].deviceType - devices[a2].deviceType
      })
      .map(addr => devices[addr])
  }

  async handleConnect(address: string) {
    if (this.connectionPending[address]) {
      return
    }

    try {
      this.connectionPending[address] = true

      await this.$store.dispatch('ble/connect', Object.assign({}, { address }))
    } catch (error) {
      console.error(error)
    } finally {
      this.connectionPending[address] = false
    }
  }

  async handleDisconnect(address: string) {
    if (this.connectionPending[address]) {
      return
    }

    try {
      this.connectionPending[address] = true

      await this.$store.dispatch('ble/disconnect', { address })
    } catch (error) {
      console.error(error)
    } finally {
      this.connectionPending[address] = false
    }
  }

  created() {
    this.$store.dispatch('ble/startScan')
  }

  destroyed() {
    this.$store.dispatch('ble/deleteUnconnectedDevices')
    this.$store.dispatch('ble/stopScan')
  }
}
